__turbopack_context__.v({
  "card": "styles-module-scss-module__Ar9Apq__card",
  "fill": "styles-module-scss-module__Ar9Apq__fill",
  "fillDanger": "styles-module-scss-module__Ar9Apq__fillDanger",
  "fillNormal": "styles-module-scss-module__Ar9Apq__fillNormal",
  "footer": "styles-module-scss-module__Ar9Apq__footer",
  "header": "styles-module-scss-module__Ar9Apq__header",
  "headerLabel": "styles-module-scss-module__Ar9Apq__headerLabel",
  "headerTier": "styles-module-scss-module__Ar9Apq__headerTier",
  "track": "styles-module-scss-module__Ar9Apq__track",
});
